import React from 'react';
import Tooltip from 'design-system/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SlackChannelActionsAddChannel = (props: $FIXME) => {
  return (
    <>
      <div className="add-container">
        <Tooltip title="Remove Channel" placement="top" arrow>
          <div
            className="remove-button"
            onClick={() =>
              props.isRecommended
                ? props.onCancelAddRecommended?.(props.channel)
                : props.onRemove?.(props.channel)
            }
          >
            <FontAwesomeIcon icon="trash" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
      </div>
      <style>{`
        .add-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
        }

        .remove-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }
      `}</style>
    </>
  );
};

export default SlackChannelActionsAddChannel;
